export default __webpack_public_path__ + "static/imda20182ndprize2-b14adec2ecf729247e9abc138ae0de35.jpg";